import { render, staticRenderFns } from "./TifTurnoRecorrido.vue?vue&type=template&id=33cca28c"
import script from "./TifTurnoRecorrido.vue?vue&type=script&lang=js"
export * from "./TifTurnoRecorrido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports